// DISABLED 成员只能 Reactivate：编辑会切到该成员身份，后端不允许切到已停用成员（会报错）
export const canShowEditAction = (canEdit: boolean, memberStatus?: string): boolean =>
    canEdit && memberStatus !== 'DISABLED';
